var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversionRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9997 14.0002H23.1064C22.5965 13.9991 22.1003 14.165 21.6937 14.4726C21.2871 14.7802 20.9924 15.2126 20.8547 15.7035L18.113 25.4568C18.0954 25.5174 18.0585 25.5706 18.008 25.6085C17.9576 25.6464 17.8962 25.6668 17.833 25.6668C17.7699 25.6668 17.7085 25.6464 17.658 25.6085C17.6076 25.5706 17.5707 25.5174 17.553 25.4568L11.113 2.5435C11.0954 2.48291 11.0585 2.42969 11.008 2.39183C10.9576 2.35396 10.8962 2.3335 10.833 2.3335C10.7699 2.3335 10.7085 2.35396 10.658 2.39183C10.6076 2.42969 10.5707 2.48291 10.553 2.5435L7.81138 12.2968C7.67426 12.7858 7.38133 13.2168 6.97706 13.5242C6.57279 13.8316 6.07925 13.9987 5.57138 14.0002H2.66638",
    stroke: "#F0A634",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversionRate);
export default __webpack_public_path__ + "static/media/conversion-rate.c7cc02e43c6dfd1bd404147fe33d982d.svg";
export { ForwardRef as ReactComponent };